<template>
    <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="sidebarx" spacer v-model="sidebarConfig.isActive" id="update-modifier">
        <div class="mt-2 flex items-center justify-between px-6 py-4">
            <h4 class="p-0 text-2xl font-bold">Update Modifier</h4>
            <feather-icon icon="XIcon" @click.stop="closeSidebar" class="cursor-pointer"></feather-icon>
        </div>
        <vs-divider class="mb-0"></vs-divider>

        <div class="sidebar-content">
            <div class="info-form p-4">
                <vs-input label="Modifier name" v-validate="'required'" name="name" v-model="name" placeholder="Input modifier name" class="w-full" :danger="errors.has('name')"
                    danger-text="The name field is required" v-on:input="checkExistName($event)" v-if="nameExist == false"/>
                <vs-input label="Modifier name" v-validate="'required'" name="name" v-model="name" placeholder="Input modifier name" class="w-full" :danger="nameExist"
                  danger-text="This name is existed" v-on:input="checkExistName($event)" v-else/>

                <vs-checkbox class="my-base mx-0 text-sm" v-model="typeModifier">Customer can only select one modifier</vs-checkbox>

                <vs-checkbox class="my-base mx-0 text-sm" v-model="requiredModifier">Required Modifier</vs-checkbox>

                <vs-row class="border-custom border-r-0 border-b-0">
                    <vs-col vs-w="4" class="border-right-custom text-center p-2 bg-custom">Modifier</vs-col>
                    <vs-col vs-w="4" class="border-right-custom text-center p-2 bg-custom">Price - $</vs-col>
                    <vs-col vs-w="4" class="border-right-custom text-center p-2 bg-custom">Remove</vs-col>
                </vs-row>
                <div class="modifier-table mb-6">
                    <vs-row class="border-custom border-r-0 border-t-0" v-for="(modifier, index) in modifier_list" :key="index">
                        <vs-col vs-w="4" class="border-right-custom text-center p-2">
                            <vs-input v-model="modifier.name" class="w-full h-full"/>
                        </vs-col>
                        <vs-col vs-w="4" class="border-right-custom text-center p-2">
                            <vs-input v-model="modifier.price" class="w-full h-full" v-on:keypress="isPriceNumber($event, modifier.price)"/>
                        </vs-col>
                        <vs-col vs-w="4" class="border-right-custom text-center p-2 flex align-center justify-center">
                            <feather-icon icon="TrashIcon" svgClasses="h-5 w-5 stroke-current text-primary" @click="removeModifier(modifier)" v-if="modifier_list.length>1"/>
                        </vs-col>
                    </vs-row>
                    <div class="add-modifier-btn-container">
                        <div class="add-modifier-btn" @click="addModifier"></div>
                    </div>
                </div>
            </div>
        </div>

        <div class="vx-row justify-center my-3" slot="footer">
            <vs-button type="filled" color="primary" @click="editMod" style="min-width: 140px;">Save</vs-button>
            <vs-button type="border" color="danger" @click="closeSidebar" style="min-width: 140px;">Cancel</vs-button>
        </div>
    </vs-sidebar>
</template>

<script>
export default {
  name: 'update-modifier',
  props:{
    sidebarConfig:{
      type : Object
    },
    sidebarData:{
      type: Object
    },
    modifierList: {
      type: Array
    }
  },
  data(){
    let modifier_list = [];
    if(this.sidebarData && this.sidebarData.details){
      for(let i=0;i<this.sidebarData.details.length;i++){
        modifier_list.push(this.sidebarData.details[i])
      }
    }
    if(modifier_list){
      for(let i = 0 ; i < modifier_list.length;i++){
        modifier_list[i].index = i;
      }
    }
    return{
      name : this.sidebarData.modifier_name,
      typeModifier : this.sidebarData.type == "multi" ? false : true,
      requiredModifier : this.sidebarData.required,
      modifier_list,
      nameExist: false
    }
  },
  methods:{
    checkExistName(evt) {
      // console.log(evt)
      this.nameExist = false;
      if(this.modifierList) {
          for(let i = 0; i < this.modifierList.length; i++) {
              if(evt.trim() == this.modifierList[i].modifier_name.trim() && this.modifierList[i].id != this.sidebarData.id) {
                  this.nameExist = true;
                  return;
              }
          }
      }
    },
    editMod(){
      for(let i = 0; i< this.modifier_list.length;){
        delete this.modifier_list[i].index
        if(this.modifier_list[i].name == ""){
          this.modifier_list.splice(i, 1);
        }else{
          i++;
        }
      }
      if(this.modifier_list && this.modifier_list.length != 0){
        if(this.name != '' && this.nameExist == false) {
          const obj = {
            id: this.sidebarData.id,
            title : this.name,
            modifier : {
              modifier_name : this.name,
              type : this.typeModifier == false ? "multi" : "single",
              required : this.requiredModifier,
              details : this.modifier_list
            }
          }
          this.$store.dispatch("modifier/UPDATE_MODIFIER", obj).then(() => {
            this.$vs.notify({
              title:'Success',
              text:'Update Modifier Success',
              color:'success',
              position:'top-right'})
          }).catch(() => {
            this.$vs.notify({
              title:'Fail',
              text:'Update Modifier Failed',
              color:'danger',
              position:'top-right'
            })
          })
          this.$emit("CloseSibarConfig");
        }
      }else{
        if(this.sidebarData && this.sidebarData.details){
          for(let i=0;i<this.sidebarData.details.length;i++){
              this.modifier_list.push(this.sidebarData.details[i])
            }
          }
          if(this.modifier_list){
            for(let i = 0 ; i < this.modifier_list.length;i++){
              this.modifier_list[i].index = i;
            }
          }
          this.$vs.notify({
            title:'Fail',
            text:'Modifier is not empty!',
            color:'danger',
            position:'top-right'
          })
      }
      this.$validator.validateAll();
    },
    addModifier() {
        this.modifier_list.push({
            index: this.modifier_list && this.modifier_list.length > 0 ? this.modifier_list[this.modifier_list.length - 1].index + 1 : 0,
            name: '',
            price: 0
        })
    },
    removeModifier(modifier) {
        for (let i = 0; i < this.modifier_list.length; i++) {
            if (this.modifier_list[i].index == modifier.index) {
                this.modifier_list.splice(i, 1);
                return;
            }
        }
    },
    closeSidebar(){
      this.$emit("CloseSibarConfig");
    },
    isPriceNumber(evt, price) {
        evt = evt ? evt : window.event;
        var charCode = evt.which ? evt.which : evt.keyCode;
        if (
            (charCode > 31 &&
            (charCode < 48 || charCode > 57) &&
            charCode !== 46) ||
            (charCode == 46 && price.indexOf(".") != -1)
        ) {
            // if (charCode > 31 && (charCode < 48 || charCode > 57)) {
            evt.preventDefault();
        } else {
            return true;
        }
    },
  }
}
</script>
